import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=351805ce&"
import script from "./Clients.vue?vue&type=script&lang=js&"
export * from "./Clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351805ce')) {
      api.createRecord('351805ce', component.options)
    } else {
      api.reload('351805ce', component.options)
    }
    module.hot.accept("./Clients.vue?vue&type=template&id=351805ce&", function () {
      api.rerender('351805ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/client/Clients.vue"
export default component.exports